/** Display order; copy lives in i18n under `experience.<id>`. */
export const experienceOrder = ['uzh', 'wiss', 'topas', 'military', 'bbz'];
